import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import BoolStore from '../../../stores/helpers/BoolStore';
import FuseReadOnlySwitch from '../../FuseControls/FuseReadOnlySwitch';

class AnonymousRegistrationField extends Component {
    static propTypes = {
        store: BoolStore.PropTypes,
        info: PropTypes.string,
        readOnly: PropTypes.bool,
    };

    render() {
        const { readOnly, store, info } = this.props;
        return <FuseReadOnlySwitch
            header="Allow Anonymous Usage"
            store={store}
            readOnly={readOnly}
            label={store.getValue() ? 'Enabled' : 'Disabled'}
            qa="anon-reg"
            tooltip={info}
            headerInfo={info}
        />;
    }
}

export default observer(AnonymousRegistrationField);
